import React from 'react';
import { Header } from '../components/Header';
import { Footer } from '../components/Footer';
import { ProductGallery } from '../components/ProductGallery';
import { ProductTitle } from '../components/ProductTitle';
import { ProductInfo } from '../components/ProductInfo';
import { ProductSpecs } from '../components/ProductSpecs';
import { CustomerLogin } from '../components/CustomerLogin';
export function ProductPage() {
  return <div className="min-h-screen bg-white font-sans text-brand-charcoal" data-id="element-1323" data-mp="5wiinyrdacld">
      <Header data-id="element-1324" data-mp="xe8b4spi8tg" />

      <main className="max-w-7xl mx-auto px-4 py-8 md:py-12" data-id="element-1325" data-mp="xxp2i6mer5w">
        {/* Top Section: Title / Gallery / Purchase.
            Mobile order (single column): H1 -> Gallery -> SKU/Made-in-USA -> Purchase -> Feeds.
            Desktop: Gallery on the left (spanning both rows), Title/SKU top-right, Purchase bottom-right. */}
        <div className="grid grid-cols-1 lg:grid-cols-[448px_minmax(0,1fr)] lg:gap-x-11" data-id="element-1326" data-mp="1q9puk5ldya3c">
          {/* Mobile-only H1 above the image (hidden on desktop, where ProductTitle renders the H1) */}
          <div className="order-1 lg:hidden mb-6" data-id="element-1327" data-mp="1cnvwtvkvaapz">
            <h1 className="text-2xl font-bold text-brand-charcoal leading-tight" data-id="element-1328" data-mp="1gp7lnyvx2rx4">
              20mm Corner Radius End Mill TuffCutt®XR Carbide 4 Flute Standard
              AlTiN Coated MA Ford
            </h1>
            <p className="mt-2 flex flex-wrap gap-x-4 gap-y-1 text-sm text-gray-500 font-mono" data-id="element-1329" data-mp="1qmvjixotkfji">
              <span data-id="element-1330" data-mp="t0xxwrf57u3c">DIA=20mm</span>
              <span data-id="element-1331" data-mp="t1zhjka85owo">LOC=38mm</span>
              <span data-id="element-1332" data-mp="xyzqc2ygl5rh">OAL=104mm</span>
              <span data-id="element-1333" data-mp="y0aq7ros9tdb">SHK=20.0mm</span>
              <span data-id="element-1334" data-mp="xx6jonnuiljh">CR=3.0mm</span>
            </p>
          </div>
          <div className="order-2 lg:order-none lg:col-start-1 lg:row-start-1 lg:row-span-2 mb-6 lg:mb-0" data-id="element-1335" data-mp="12xkfn7c6a515">
            <ProductGallery data-id="element-1336" data-mp="17qnarjwllmjg" />
          </div>
          <div className="order-3 lg:order-none lg:col-start-2 lg:row-start-1 mb-4" data-id="element-1337" data-mp="a9oki7294l6h">
            <ProductTitle data-id="element-1338" data-mp="a7u9bkgs87fl" />
          </div>
          <div className="order-4 lg:order-none lg:col-start-2 lg:row-start-2" data-id="element-1339" data-mp="f7zxurrr9dtg">
            <ProductInfo data-id="element-1340" data-mp="77k3o5shet39" />
          </div>
        </div>

        {/* Middle Section: Specs */}
        <ProductSpecs data-id="element-1341" data-mp="36qdt6vhb47q" />

        {/* Bottom Section: Login */}
        <CustomerLogin data-id="element-1342" data-mp="368d9y1sa3u0" />
      </main>

      <Footer data-id="element-1343" data-mp="gxlpeqxd3zf0" />
    </div>;
}